function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8868 6.63146L13.4135 7.10479L9.64014 3.33146L10.1135 2.85812C10.6335 2.33812 11.3201 2.07812 12.0001 2.07812C12.6801 2.07812 13.3668 2.33812 13.8868 2.85812C14.4068 3.37812 14.6668 4.06479 14.6668 4.74479C14.6668 5.42479 14.4068 6.11146 13.8868 6.63146ZM2.4735 10.4982L8.70016 4.27148L12.4668 8.04482L6.24016 14.2715C5.88683 14.6248 5.44683 14.8248 4.9935 14.9782C4.54016 15.1315 4.06683 15.2248 3.62683 15.2848C2.74683 15.4115 2.02016 15.4115 2.00016 15.4115C1.82683 15.4115 1.6535 15.3382 1.52683 15.2182C1.40683 15.0915 1.3335 14.9182 1.3335 14.7448C1.3335 14.7315 1.3335 14.3182 1.38683 13.7315C1.44016 13.1582 1.54016 12.4248 1.76683 11.7448C1.92016 11.2915 2.12016 10.8515 2.4735 10.4982Z",
  fill: "white"
});

function SvgImageViewerEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageViewerEdit);
export default __webpack_public_path__ + "static/media/image-viewer-edit.df89e6e7.svg";
export { ForwardRef as ReactComponent };